import React, { useMemo } from 'react'
import Select from '../../common/components/Select'

import { useIncidents } from '../hooks'

const IncidentSelector = ({ setIncidentId, incidentId }) => {
  const [{ response: incidents, isLoading }] = useIncidents()

  const incidentOptions = useMemo(() => {
    if (isLoading || !incidents) return []
    const options = incidents.map((incident) => ({
      value: incident.id,
      label: incident.name,
    }))
    return incidentId
      ? options
      : [{ label: 'Select an Incident', value: null }, ...options]
  }, [incidents, isLoading, incidentId])

  return (
    <div style={{ color: 'black', width: '50%', minWidth: 250 }}>
      <Select
        label="Incident"
        options={incidentOptions}
        value={incidentId}
        onChange={setIncidentId}
      />
    </div>
  )
}

export default IncidentSelector
